// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AnalyticsController from './analytics_controller';
application.register('analytics', AnalyticsController);

import CarouselController from './carousel_controller';
application.register('carousel', CarouselController);

import CheckboxesController from './checkboxes_controller';
application.register('checkboxes', CheckboxesController);

import ClipboardController from './clipboard_controller';
application.register('clipboard', ClipboardController);

import CookieController from './cookie_controller';
application.register('cookie', CookieController);

import CssController from './css_controller';
application.register('css', CssController);

import CycleController from './cycle_controller';
application.register('cycle', CycleController);

import DateFilterController from './date_filter_controller';
application.register('date-filter', DateFilterController);

import DateFormController from './date_form_controller';
application.register('date-form', DateFormController);

import DebouncedInputController from './debounced_input_controller';
application.register('debounced-input', DebouncedInputController);

import DomController from './dom_controller';
application.register('dom', DomController);

import EventController from './event_controller';
application.register('event', EventController);

import ExpansionPanelController from './expansion_panel_controller';
application.register('expansion-panel', ExpansionPanelController);

import FileController from './file_controller';
application.register('file', FileController);

import FormController from './form_controller';
application.register('form', FormController);

import FormDataController from './form_data_controller';
application.register('form-data', FormDataController);

import GmapsBoundsController from './gmaps_bounds_controller';
application.register('gmaps-bounds', GmapsBoundsController);

import GmapsInfowindowController from './gmaps_infowindow_controller';
application.register('gmaps-infowindow', GmapsInfowindowController);

import GmapsInteractionController from './gmaps_interaction_controller';
application.register('gmaps-interaction', GmapsInteractionController);

import GmapsOptionsController from './gmaps_options_controller';
application.register('gmaps-options', GmapsOptionsController);

import GmapsRadiusController from './gmaps_radius_controller';
application.register('gmaps-radius', GmapsRadiusController);

import GoogleplacesController from './googleplaces_controller';
application.register('googleplaces', GoogleplacesController);

import HibpController from './hibp_controller';
application.register('hibp', HibpController);

import ImageConversionController from './image_conversion_controller';
application.register('image-conversion', ImageConversionController);

import InputPrefixController from './input_prefix_controller';
application.register('input-prefix', InputPrefixController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import NoTurboVisitsController from './no_turbo_visits_controller';
application.register('no-turbo-visits', NoTurboVisitsController);

import NumberFilterController from './number_filter_controller';
application.register('number-filter', NumberFilterController);

import ObfuscationController from './obfuscation_controller';
application.register('obfuscation', ObfuscationController);

import OptionFilterController from './option_filter_controller';
application.register('option-filter', OptionFilterController);

import PropagateController from './propagate_controller';
application.register('propagate', PropagateController);

import QueryParametersController from './query_parameters_controller';
application.register('query-parameters', QueryParametersController);

import RadiusSearchController from './radius_search_controller';
application.register('radius-search', RadiusSearchController);

import ScreenController from './screen_controller';
application.register('screen', ScreenController);

import ScrollController from './scroll_controller';
application.register('scroll', ScrollController);

import SelectController from './select_controller';
application.register('select', SelectController);

import SetByOverflowController from './set_by_overflow_controller';
application.register('set-by-overflow', SetByOverflowController);

import SortableController from './sortable_controller';
application.register('sortable', SortableController);

import SwipeController from './swipe_controller';
application.register('swipe', SwipeController);

import ToggleController from './toggle_controller';
application.register('toggle', ToggleController);

import TooltipController from './tooltip_controller';
application.register('tooltip', TooltipController);

import TrixToolbarController from './trix_toolbar_controller';
application.register('trix-toolbar', TrixToolbarController);

import TurboController from './turbo_controller';
application.register('turbo', TurboController);

import VisitController from './visit_controller';
application.register('visit', VisitController);
